<script>

export default {
  name: 'TvCallPatient',
  data() {
    return {
      empresa: null,
      listCalls: [],
      call: null,
      statusClinicChannel: false,
      errorClinicChannel: null,
      currentTime: '',
      timeInterval: null,
      // Slideshow properties
      mediaItems: [],
      currentIndex: 0,
      slideInterval: null,
      mediaDirectory: '@/assets/media/tv/', // Caminho configurável para as mídias
      defaultImage: null, // Imagem padrão (index.png) para fallback em caso de erro
      iframes: [
        {
          type: 'iframe',
          src: 'https://api.wo-cloud.com/content/widget/?geoObjectKey=9657556&language=pt&region=BR&timeFormat=HH:mm&windUnit=kmh&systemOfMeasurement=metric&temperatureUnit=celsius',
          name: 'Petrolina-PE'
        },
        {
          type: 'iframe',
          src: 'https://api.wo-cloud.com/content/widget/?geoObjectKey=16109176&language=pt&region=BR&timeFormat=HH:mm&windUnit=kmh&systemOfMeasurement=metric&temperatureUnit=celsius',
          name: 'Juazeiro-BA'
        },
        {
          type: 'iframe',
          src: 'https://api.wo-cloud.com/content/widget/?geoObjectKey=11055411&language=pt&region=BR&timeFormat=HH:mm&windUnit=kmh&systemOfMeasurement=metric&temperatureUnit=celsius',
          name: 'Recife-PE'
        }
      ]
    }
  },
  created() {
    this.empresa = JSON.parse(localStorage.getItem('currentEmpresa'));

    if (!this.empresa) {
        console.warn('Empresa não encontrada no localStorage. Redirecionando...');
        // Implementar redirecionamento ou mostrar erro
        return;
    }

    const channelName = `clinic.calls.${this.empresa.id}`;
    const channel = window.pusher.subscribe(channelName);

    channel.bind('pusher:subscription_succeeded', () => {
      this.statusClinicChannel = true;
      console.log('Inscrição no canal realizada com sucesso!');
    });
    channel.bind('pusher:subscription_error', (status) => {
      this.errorClinicChannel = JSON.stringify(status);
      console.log('Erro ao conectar ao canal', channelName, status);
    });

    // 5. Listener do Evento Específico
    // O nome do evento foi definido como 'PatientCalled' no método broadcastAs()
    channel.bind('PatientCalled', (data) => {
      console.log('Payload recebido:', data);
      
      // Tocar som de notificação quando receber nova chamada
      try {
        if (this.playNotificationSound) {
          this.playNotificationSound();
        }
      } catch (error) {
        console.warn('Erro ao tocar som de notificação:', error);
      }
      
      this.call = data;
      this.listCalls.unshift(data);
      if (this.listCalls.length > 4) {
        this.listCalls.pop();
      }
      while (this.listCalls.length < 4) {
        this.listCalls.push({});
      }
    });
  },
  mounted() {
    this.updateTime();
    this.timeInterval = setInterval(() => {
      this.updateTime();
    }, 1000);
    this.loadMediaFiles();
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    if (this.slideInterval) {
      clearTimeout(this.slideInterval);
    }
  },
  computed: {
    // Formato brasileiro dd de mmm de yyyy hh:mm:ss
    dateBR() {
      return new Date().toLocaleString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
    },
    timeBR() {
      return this.currentTime;
    },
    currentMedia() {
      if (this.mediaItems.length === 0) return null;
      return this.mediaItems[this.currentIndex];
    },
    isVideo() {
      return this.currentMedia && this.currentMedia.type === 'video';
    },
    isImage() {
      return this.currentMedia && this.currentMedia.type === 'image';
    },
    isIframeBlock() {
      return this.currentMedia && this.currentMedia.type === 'iframe-block';
    }
  },
  methods: {
    updateTime() {
      this.currentTime = new Date().toLocaleString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    getCalls() {
      this.echo.channel('clinic.calls.' + this.empresa.id).listen('PatientCalled', (e) => {
          // incluir no formato de fila onde o último adicionado vai substituindo o primeiro
          // deve guardar até 4 registros
          // caso não tenha 4, incluir objetos vazios até completar 4
        this.listCalls.push(e.call);
        this.listCalls.sort((a, b) => b.id - a.id);
        this.call = this.listCalls[0];
        while (this.listCalls.length < 4) {
          this.listCalls.push({});
        }
      });
    },
    // Carrega lista de imagens e vídeos do diretório
    loadMediaFiles() {
      try {
        const mediaFiles = [];
        
        // Carregar arquivos do diretório usando require.context
        // Suporta: imagens (png, jpg, jpeg, gif, webp, bmp) e vídeos (mp4, webm, ogg, mov)
        const requireMedia = require.context('@/assets/media/tv', false, /\.(png|jpg|jpeg|gif|webp|bmp|mp4|webm|ogg|mov)$/i);
        
        requireMedia.keys().forEach((fileName) => {
          // Remover o './' do início do nome do arquivo
          const cleanFileName = fileName.replace(/^\.\//, '');
          const filePath = requireMedia(fileName);
          
          // Se for index.png, armazenar como imagem padrão para fallback
          if (cleanFileName.toLowerCase() === 'index.png') {
            this.defaultImage = filePath;
          } else {
            // Adicionar outros arquivos à lista de mídias
            mediaFiles.push({
              name: cleanFileName,
              src: filePath, // require.context retorna o caminho processado pelo webpack
              url: filePath,
              hasError: false // Flag para rastrear se houve erro no carregamento
            });
          }
        });
        
        // Se não encontrou index.png, tentar carregar diretamente
        if (!this.defaultImage) {
          try {
            this.defaultImage = require('@/assets/media/tv/index.png');
          } catch (e) {
            console.warn('Imagem padrão index.png não encontrada');
          }
        }
        
        console.log('Arquivos de mídia carregados:', mediaFiles);
        console.log('Imagem padrão (fallback):', this.defaultImage);
        
        // Construir playlist intercalando iframes com mídias
        this.buildMediaPlaylist(mediaFiles);
      } catch (error) {
        console.error('Erro ao carregar mídias:', error);
        // Se houver erro, apenas exibir os iframes
        this.buildMediaPlaylist([]);
      }
    },
    // Constrói a playlist intercalando o bloco dos 3 iframes com as mídias
    buildMediaPlaylist(mediaFiles) {
      this.mediaItems = [];
      
      // Se não houver mídias, apenas criar um loop dos iframes
      if (mediaFiles.length === 0) {
        this.mediaItems.push({
          type: 'iframe-block',
          iframes: this.iframes,
          duration: 20000 // 20 segundos
        });
        this.startSlideshow();
        return;
      }
      
      // Intercalar iframes com mídias
      for (let i = 0; i < mediaFiles.length; i++) {
        // Adicionar bloco de iframes antes de cada mídia
        this.mediaItems.push({
          type: 'iframe-block',
          iframes: this.iframes,
          duration: 20000 // 20 segundos
        });
        
        // Adicionar mídia
        const file = mediaFiles[i];
        const extension = file.name ? file.name.toLowerCase().substring(file.name.lastIndexOf('.')) : '';
        const isVideo = ['.mp4', '.webm', '.ogg', '.mov'].includes(extension);
        
        this.mediaItems.push({
          type: isVideo ? 'video' : 'image',
          src: file.src || file.url, // require.context já retorna o caminho processado
          duration: isVideo ? 30000 : 20000, // Vídeos: 30s, Imagens: 20s
          hasError: false, // Flag para rastrear se houve erro no carregamento
          originalSrc: file.src || file.url // Manter referência ao src original
        });
      }
      
      // Adicionar um último bloco de iframes no final para fechar o ciclo
      this.mediaItems.push({
        type: 'iframe-block',
        iframes: this.iframes,
        duration: 20000
      });

      console.log('mediaItems', this.mediaItems);
      
      this.startSlideshow();
    },
    // Inicia o slideshow com timers apropriados
    startSlideshow() {
      if (this.mediaItems.length === 0) return;
      
      // Limpar intervalo anterior se existir
      if (this.slideInterval) {
        clearTimeout(this.slideInterval);
        this.slideInterval = null;
      }
      
      // Começar do primeiro item
      this.currentIndex = 0;
      
      // Obter duração do item atual
      const currentItem = this.mediaItems[this.currentIndex];
      const duration = this.getDisplayDuration(currentItem);
      
      // Configurar intervalo para próximo slide
      this.slideInterval = setTimeout(() => {
        this.nextSlide();
      }, duration);
    },
    // Avança para o próximo item
    nextSlide() {
      if (this.mediaItems.length === 0) return;
      
      // Limpar timeout anterior se existir
      if (this.slideInterval) {
        clearTimeout(this.slideInterval);
        this.slideInterval = null;
      }
      
      // Avançar para o próximo índice
      this.currentIndex = (this.currentIndex + 1) % this.mediaItems.length;
      
      // Obter duração do novo item atual
      const currentItem = this.mediaItems[this.currentIndex];
      const duration = this.getDisplayDuration(currentItem);
      
      // Configurar intervalo para próximo slide
      this.slideInterval = setTimeout(() => {
        this.nextSlide();
      }, duration);
    },
    // Retorna duração baseada no tipo de mídia
    getDisplayDuration(item) {
      if (!item) return 20000; // Default 20 segundos
      
      if (item.duration) {
        return item.duration;
      }
      
      if (item.type === 'video') {
        return 30000; // 30 segundos para vídeos
      }
      
      if (item.type === 'image') {
        return 20000; // 20 segundos para imagens
      }
      
      if (item.type === 'iframe-block') {
        return 20000; // 20 segundos para iframes
      }
      
      return 20000; // Default
    },
    // Tratamento de erro para mídias que falharem ao carregar
    handleMediaError(event) {
      console.error('Erro ao carregar mídia:', event);
      
      const currentItem = this.mediaItems[this.currentIndex];
      
      if (!currentItem) {
        this.nextSlide();
        return;
      }
      
      // Se já tentou usar a imagem padrão e ainda deu erro, pular para o próximo
      if (currentItem.hasError) {
        console.warn('Mídia padrão também falhou, pulando para próximo slide');
        this.nextSlide();
        return;
      }
      
      // Se houver imagem padrão disponível e a mídia atual não for iframe
      if (this.defaultImage && currentItem.type !== 'iframe-block') {
        console.log('Substituindo mídia com erro pela imagem padrão (index.png)');
        
        // Marcar que houve erro
        this.$set(currentItem, 'hasError', true);
        
        // Substituir por imagem padrão
        this.$set(currentItem, 'type', 'image');
        this.$set(currentItem, 'src', this.defaultImage);
        this.$set(currentItem, 'duration', 20000); // 20 segundos para a imagem padrão
        
        // Usar nextTick para garantir que a atualização aconteça
        this.$nextTick(() => {
          // Forçar atualização se necessário
          this.$forceUpdate();
        });
      } else {
        // Se não houver imagem padrão ou for iframe, pular para o próximo slide
        this.nextSlide();
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="layout-wrapper">
      <header>
        <div class="col">
          <div class="row">
            <div class="col-4">
              <span style="font-size: 24px;">{{ empresa ? empresa.fantasia : 'EasySaúde' }}</span>
            </div>
            <div class="col-4 datetime">
              <span id="date">{{ dateBR }} </span>
              <span id="time" style="font-size: 28px;">{{ timeBR }}</span>
            </div>
            <div class="col-4 text-right">
              <img class="img-responsive" src="https://sidsolucoes.com/img/logo-light.ba5a31a0.png" alt="Logo" style="width: 160px;">
            </div>
          </div>
        </div>
      </header>
      <div class="main">
        <div class="page">
          <div class="w-full">
            <div class="row">
              <div class="col-4">
                <div v-if="call !== null" class="card">
                  <div class="card-header">
                    <h1 class="text-center bg-light p-3 m-2">{{ call.room }}</h1>
                  </div>
                  <div class="card-body">
                    <h3 class="text-center">{{ call.patient_name }}</h3>
                    <h5 class="text-center bg-success text-white p-3 m-4">{{ call.professional_name }}</h5>
                  </div>
                  <div class="card-footer">
                    <p>Atenção, dirija-se até a sala para atendimento...</p>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <div class="carrocel" style="background-color: rgb(22 28 45);">
                  <div class="slideshow-container">
                    <!-- Bloco dos 3 iframes (sempre exibidos juntos) -->
                    <transition name="fade" mode="out-in">
                    <div v-if="isIframeBlock && currentMedia" key="iframes" class="row text-white slideshow-item">
                    <div class="col-12 text-left">
                          <iframe 
                            v-for="(iframe, idx) in currentMedia.iframes" 
                            :key="idx"
                            :src="iframe.src" 
                            :name="iframe.name" 
                            scrolling="no" 
                            width="318" 
                            height="318" 
                            frameborder="0" 
                            style="border: 1px solid #10658E;border-radius: 8px; margin-right: 6px;">
                          </iframe>
                        </div>
                      </div>
                      
                      <!-- Vídeo -->
                      <div v-else-if="isVideo && currentMedia" :key="`video-${currentIndex}-${currentMedia.hasError ? 'error' : 'normal'}`" class="slideshow-item slideshow-media">
                        <video 
                          :src="currentMedia.src" 
                          autoplay 
                          muted 
                          playsinline
                          loop
                          class="slideshow-video"
                          @error="handleMediaError">
                        </video>
                      </div>
                      
                      <!-- Imagem -->
                      <div v-else-if="isImage && currentMedia" :key="`image-${currentIndex}-${currentMedia.hasError ? 'error' : 'normal'}`" class="slideshow-item slideshow-media">
                        <img 
                          :src="currentMedia.src" 
                          alt="Slideshow image" 
                          class="slideshow-image"
                          @error="handleMediaError">
                    </div>
                    </transition>
                  </div>
                  <template v-if="false">
                    <div v-for="call in listCalls" :key="call.id" class="row pl-4 text-white">
                      <div class="col-12 p-2 m-2">
                        <h4>{{ call.patient_name }}</h4>
                        <p>{{ call.professional_name }}</p>
                        <p>{{ call.room }}</p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="col">
          <div class="row">
            <div class="col-md-3" v-for="call in listCalls" :key="call.id">
              <h3 class="text-white">{{ call.room }}</h3>
              <h5 class="text-white">{{ call.patient_name }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
body {
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    font-family: Arial, sans-serif;
    overflow: hidden;
}
.tv-container {
    width: 100vw;
    height: 100vh;
    background-color: white;
}
header {
    background-color: rgb(22 28 45);
    color: white;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
}
.container-fluid {
  background-color: #f1f5f7;
}
.datetime {
  text-align: right;
  font-size: 18px;
}
.footer {
  background-color: rgb(22 28 45);
  color: white;
  padding: 20px;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100vw;
  justify-content: space-around;
  box-shadow: 0 -4px 6px rgba(0,0,0,0.3);
  height: 100px;
}

.carrocel {
  max-height: 65vh;
  overflow-y: auto;
}

.carrocel::-webkit-scrollbar {
  width: 10px;
}

.carrocel::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.carrocel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

.carrocel::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Slideshow styles */
.slideshow-container {
  position: relative;
  width: 100%;
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slideshow-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slideshow-media {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slideshow-video {
  max-width: 100%;
  max-height: 65vh;
  width: auto;
  height: auto;
  border: 1px solid #10658E;
  border-radius: 8px;
  object-fit: contain;
}

.slideshow-image {
  max-width: 100%;
  max-height: 65vh;
  width: auto;
  height: auto;
  border: 1px solid #10658E;
  border-radius: 8px;
  object-fit: contain;
}

/* Fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
